import React from 'react';
import Navbar from './Navbar';
import Bottombar from './Bottombar';
import Hero from './Hero';
import heroImage from '../Website/5101597.jpg';
import './HomePage.css';

/* ── Client logo data — uses logos from /src/clients/ ── */
const clientLogos = [
  { name: 'Boeing',             file: 'Boeing' },
  { name: 'Lockheed Martin',    file: 'LockheedMartin' },
  { name: 'SpaceX',             file: 'SpaceX' },
  { name: 'Collins Aerospace',  file: 'CollinsAerospace' },
  { name: 'Google Pixel',       file: 'GooglePixel' },
  { name: 'T-Mobile',           file: 'T-Mobile' },
  { name: 'Motorola Solutions', file: 'MotorolaSolutions' },
  { name: 'Hughes Network',     file: 'HughesNetworkSystems' },
  { name: 'Zebra Technologies', file: 'ZebraTechnologies' },
  { name: 'ASML',               file: 'ASML' },
  { name: 'Trimble',            file: 'Trimble' },
  { name: 'Trane Technologies', file: 'TraneTechnologies' },
  { name: 'Analog Devices',     file: 'AnalogDevices' },
  { name: 'SunPower',           file: 'SunPower' },
  { name: 'AHRQ',               file: 'AHRQ(AgencyforHealthcareResearchandQuality)' },
];

/* Load logos safely */
const loadedLogos = clientLogos.map(c => {
  let src = null;
  try { src = require(`../clients/${c.file}.png`); } catch (_) {}
  return { ...c, src };
});

const doubled = [...loadedLogos, ...loadedLogos];

/* ── Differentiator items ── */
const differentiators = [
  {
    label: 'Our People',
    detail: 'Skilled, dedicated professionals across every discipline',
    icon: (
      <svg viewBox="0 0 24 24" strokeWidth={1.5}>
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    ),
  },
  {
    label: 'Performance-Based Processes',
    detail: 'Measurable, outcome-driven delivery that scales',
    icon: (
      <svg viewBox="0 0 24 24" strokeWidth={1.5}>
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
      </svg>
    ),
  },
  {
    label: 'Integrated Solutions Teams',
    detail: 'Cross-functional expertise on every engagement',
    icon: (
      <svg viewBox="0 0 24 24" strokeWidth={1.5}>
        <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
        <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
      </svg>
    ),
  },
  {
    label: 'Technology × Business',
    detail: 'Strategic mix bridging engineering depth and business acumen',
    icon: (
      <svg viewBox="0 0 24 24" strokeWidth={1.5}>
        <circle cx="12" cy="12" r="10"/>
        <path d="M12 8v4l3 3"/>
      </svg>
    ),
  },
];

/* ── Service highlights ── */
const serviceHighlights = [
  {
    title: 'Embedded Systems',
    desc: 'IoT, Avionics, Tactical Radios, C4ISR, Autonomous Vehicles — full lifecycle from prototype to production.',
    icon: (
      <svg viewBox="0 0 24 24" strokeWidth={1.5}><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 3H8L6 7h12l-2-4z"/><circle cx="12" cy="14" r="2"/></svg>
    ),
  },
  {
    title: 'Cybersecurity',
    desc: 'Product Security Assurance, STRIDE analysis, PenTesting, TPM, TrustZone, and FIPS-compliant solutions.',
    icon: (
      <svg viewBox="0 0 24 24" strokeWidth={1.5}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
    ),
  },
  {
    title: 'Cloud & DevOps',
    desc: 'AWS-powered scalable architectures, CI/CD pipelines, and managed infrastructure for government and commercial clients.',
    icon: (
      <svg viewBox="0 0 24 24" strokeWidth={1.5}><path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"/></svg>
    ),
  },
  {
    title: 'Software Engineering',
    desc: 'Full-stack development, mobile (iOS/Android), web portals, and device drivers for Linux, FreeRTOS, VxWorks.',
    icon: (
      <svg viewBox="0 0 24 24" strokeWidth={1.5}><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>
    ),
  },
  {
    title: 'Consulting',
    desc: 'Business strategy, CMMI process development, change management, financial analysis, and security assessments.',
    icon: (
      <svg viewBox="0 0 24 24" strokeWidth={1.5}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
    ),
  },
  {
    title: 'Telecom & Networking',
    desc: 'DMVPN, SDR, command-post architecture, satellite communication, and secure data transfer solutions.',
    icon: (
      <svg viewBox="0 0 24 24" strokeWidth={1.5}><path d="M5 12.55a11 11 0 0 1 14.08 0"/><path d="M1.42 9a16 16 0 0 1 21.16 0"/><path d="M8.53 16.11a6 6 0 0 1 6.95 0"/><circle cx="12" cy="20" r="1"/></svg>
    ),
  },
];

const HomePage = () => (
  <>
    <Navbar />

    {/* ── Hero — centered ── */}
    <div className="homepage">
      <Hero
        image={heroImage}
    
        title={<>Technology Solutions<br />Built for Mission-Critical Work</>}
      />
    </div>

    {/* ── Stats ban-ctd ── */}
    <div className="homepage-intro">
      <div className="homepage-intro-inner">
        <div className="intro-stat">
          <span className="stat-number">50+</span>
          <span className="stat-label">Enterprise Clients</span>
        </div>
        <div className="intro-divider" />
        <div className="intro-stat">
          <span className="stat-number">9</span>
          <span className="stat-label">Core Service Areas</span>
        </div>
        <div className="intro-divider" />
        <div className="intro-stat">
          <span className="stat-number">100%</span>
          <span className="stat-label">Client Retention</span>
        </div>
      </div>
    </div>

    {/* ── Client logo marquee ── */}
    <div className="homepage-marquee">
      <p className="marquee-label">Trusted by industry leaders</p>
      <div className="marquee-track">
        {doubled.map((c, i) => (
          <div className="marquee-logo-pill" key={i} title={c.name}>
            {c.src ? (
              <img src={c.src} alt={c.name} />
            ) : (
              <span className="marquee-logo-text">{c.name}</span>
            )}
          </div>
        ))}
      </div>
    </div>

    {/* ── About ── */}
    <section style={{ background: '#ffffff' }}>
      <div className="homepage-about">
        <div className="about-headline-col">
          <span className="section-label">Who We Are</span>
          <h2>Your Partner in <em>Innovative</em> IT Solutions</h2>
          <div className="about-rule" />
          <div className="about-body">
            <p>
              Softick LLC provides <strong>strategic consulting, technology, and managed services</strong> to commercial, non-profit, and government organizations.
            </p>
            <p>
              As a <strong>Minority-Owned Small Business</strong>, we take your product through the complete lifecycle — from prototype to production — in a timely, cost-effective manner.
            </p>
          </div>
          <div className="about-buttons">
            <a href="/services" className="btn-primary">Our Services →</a>
            <a href="/contact" className="btn-secondary">Get in Touch</a>
          </div>
        </div>

        {/* Feature cards */}
        <div className="about-features">
          {differentiators.map((d) => (
            <div className="about-feature-item" key={d.label}>
              <div className="about-feature-icon">{d.icon}</div>
              <div className="about-feature-text">
                <strong>{d.label}</strong>
                <span>{d.detail}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* ── Services grid ── */}
    <section className="homepage-services">
      <div className="homepage-services-inner">
        <div className="section-header">
          <div className="section-header-text">
            <span className="section-label">What We Do</span>
            <h2>Services &amp; Capabilities</h2>
          </div>
          <a href="/services" className="section-link">View all services →</a>
        </div>
        <div className="services-grid">
          {serviceHighlights.map((s) => (
            <div className="service-card" key={s.title}>
              <div className="service-card-icon">{s.icon}</div>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* ── CTA ── */}
    <section className="homepage-cta">
  <div className="homepage-cta-inner">
    <div className="homepage-cta-text">
      <span className="section-label">Let's Work Together</span>
      <h2>Ready to Build Something Mission-Critical?</h2>
      <p>From prototype to production — on time, on budget.</p>
    </div>
    <div className="homepage-cta-actions">
      <a href="/contact" className="btn-primary">Get in Touch →</a>
      <a href="/services" className="btn-secondary">Our Services</a>
    </div>
  </div>
</section>
    <Bottombar />
  </>
);

export default HomePage;